import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { User } from "../models/user.model";
import { signInUser } from "../Components/Utility/Auth";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

const user = signInUser()
// @ts-ignore
const { aamarId = "", warehouse = "" } = user || {};

export const UserApi = createApi({
  reducerPath: "UserApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["User"],
  endpoints: (builder) => ({
    Users: builder.query<User[], any>({
      query: ({ warehouse, aamarId }) =>
        `/user/${warehouse && warehouse !== "undefined" ? warehouse : "allWh"}/${aamarId || ""}`,
      providesTags: ["User"],
    }),
    User: builder.query<User, any>({
      query: (id) => `/user/${id}`,
      providesTags: ["User"],
    }),
    
    UserCount: builder.query<User[], any>({
      query: ({aamarId}) => `/user/count/${aamarId}`,
      providesTags: ["User"],
    }),
    UserDw: builder.query<User, string>({
      query: () => `/user/Dw`,
      providesTags: ["User"],
    }),
    BillerDw: builder.query<User, string>({
      query: (warehouse) => `/user/biller/${warehouse}`,
      providesTags: ["User"],
    }),
    ManagerDw: builder.query<User, string>({
      query: () => `/user/manager/${aamarId}/${warehouse}`,
      providesTags: ["User"],
    }),
    addUser: builder.mutation<{}, User>({
      query: (User) => ({
        url: "/user/register",
        method: "POST",
        body: User,
      }),
      invalidatesTags: ["User"],
    }),
    loginUser: builder.mutation<{}, User>({
      query: (User) => ({
        url: "/user/login",
        method: "POST",
        body: User,
      }),
      invalidatesTags: ["User"],
    }),
    validUser: builder.mutation<{}, User>({
      query: (User) => ({
        url: "/user/valid",
        method: "POST",
        body: User,
      }),
      invalidatesTags: ["User"],
    }),
    updateUser: builder.mutation<void, User>({
      query: ({ _id, ...rest }) => ({
        url: `/user/${_id}`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["User"],
    }),
    deleteUser: builder.mutation<void, string>({
      query: (id) => ({
        url: `/user/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const {
  useUsersQuery,
  useUserCountQuery,
  useUserQuery,
  useAddUserMutation,
  useLoginUserMutation,
  useUpdateUserMutation,
  useValidUserMutation,
  useDeleteUserMutation,
  useUserDwQuery,
  useBillerDwQuery,
  useManagerDwQuery,
} = UserApi;

export default UserApi;
